import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export async function fetchApi(endpoint, options = {}) {
  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Request failed' }));
    
    // Handle Pydantic validation errors (FastAPI returns these in a specific format)
    if (error.detail && Array.isArray(error.detail)) {
      // Pydantic validation errors come as array of {loc, msg, type}
      const messages = error.detail.map(err => {
        const field = err.loc ? err.loc[err.loc.length - 1] : 'field';
        return err.msg || `Invalid ${field}`;
      });
      throw new Error(messages.join('. '));
    }
    
    // Handle string detail (normal HTTP errors)
    if (typeof error.detail === 'string') {
      throw new Error(error.detail);
    }
    
    // Handle other error formats
    throw new Error(error.message || error.detail || 'Request failed');
  }
  
  return response.json();
}

export function formatNumber(num) {
  if (num === null || num === undefined) return '-';
  if (Math.abs(num) >= 1e12) return (num / 1e12).toFixed(2) + 'T';
  if (Math.abs(num) >= 1e9) return (num / 1e9).toFixed(2) + 'B';
  if (Math.abs(num) >= 1e6) return (num / 1e6).toFixed(2) + 'M';
  if (Math.abs(num) >= 1e3) return (num / 1e3).toFixed(2) + 'K';
  return num.toFixed(2);
}

export function formatPrice(price) {
  if (price === null || price === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
}

export function formatPercent(value) {
  if (value === null || value === undefined) return '-';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
}

export function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

export function formatTimeAgo(date) {
  if (!date) return '-';
  const d = new Date(date);
  const now = new Date();
  const diff = (now - d) / 1000;
  
  if (diff < 60) return 'Just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(date);
}

export function getChangeColor(value) {
  if (value > 0) return 'text-up';
  if (value < 0) return 'text-down';
  return 'text-muted-foreground';
}

export function getChangeBg(value) {
  if (value > 0) return 'bg-up';
  if (value < 0) return 'bg-down';
  return 'bg-muted';
}
